import React, { Component } from 'react'
import { compose } from 'recompose'
import { LayoutPlain, Header, Footer } from 'components/layout'
import { Login, Register } from 'containers/forms/auth'
import { meta } from 'helpers/decorators'
import { apiAnnouncements, apiOrganizations } from 'helpers/decorators/api'
import { get } from 'lodash'
import { Banner, Announcement } from 'components/misc'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { matchPath } from 'react-router'
import config from '../../../config'
import MfaCodeModal from '../../../components/modals/MfaCodeModal/MfaCodeModal'
import MODALS from '../../../constants/layout/modals'


const enhance = compose(
  meta({
    title: 'Landing page',
    intlKey: 'route.landing_page'
  }),
  apiAnnouncements(),
  apiOrganizations(),
  connect(
    ({ api, app }) => ({
      customization: api.organizations.customization,
      loading: api.organizations.loading,
      localeCode: app.locale.code
    }),
    {}
  )
)

class CustomHome extends Component {
  static propTypes = {
    announcements: PropTypes.object,
    onGetOrganizationClientCustomization: PropTypes.func,
    customization: PropTypes.object,
    localeCode: PropTypes.string,
    loading: PropTypes.bool
  }

  componentDidMount = async () => {
    if (!get(this.props, 'customization.locale')) {
      const match = matchPath(get(this.props, 'location.pathname'), {
        path: `${config.publicPath}/:code([a-z0-9]{2})`,
        exact: true,
        strict: false
      })

      if (match) {
        const code = get(match, 'params.code', "")
        await this.props.onGetOrganizationClientCustomization(code)
      }
    }
  }

  render () {
    const { announcements, customization, loading } = this.props

    const logoUrl = get(customization, 'organization.logoUrl')

    const currentLocale = get(this.props, 'currentLocale')

    const descriptionMap = get(customization, 'descriptionMap.descriptionMap')

    const description = descriptionMap && descriptionMap[currentLocale]

    return (<div>
      {!loading && <LayoutPlain
        header={<Header logoUrl={logoUrl} />}
        footer={<Footer />}
        banner={<Banner />}
        description={description}
        announcement={<Announcement announcements={announcements} />}
        body={[<Login {...this.props} />, <Register {...this.props} />]}
        colWidth="320px"
        divider
      >
        <MfaCodeModal modalId={MODALS.SET_MFA_CODE} />
      </LayoutPlain>}
      </div>
    )
  }
}

export default enhance(CustomHome)
